import "./StartYourProject.module.css";
import Header from "@/reusable_sections/Header";
import VideoHero from "./sections/VideoHero";
import GetInTouch from "./sections/GetInTouch";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import PulseMetricsFooter from "@/reusable_sections/Footer";
export default function StartYourProjectPage() {
  return <div>
      <Header />
      <VideoHero />
      <GetInTouch />
      <FrequentlyAskedQuestions />
      <PulseMetricsFooter />
    </div>;
}